var DepartmentService = function () {
  var departments = []
  var departmentsByDepartmentId = {}
  var departmentsByRegionId = {}

  return {
    getDepartments: function () {
      return departments
    },
    getDepartmentByDepartmentId: function (departmentId) {
      return departmentsByDepartmentId[departmentId]
    },
    getDepartmentsByRegionId: function (regionId) {
      return departmentsByRegionId[regionId] || []
    },
    setDepartments: function (_departments) {
      departmentsByDepartmentId = {}
      departmentsByRegionId = {}

      departments = _departments
      departments.forEach(function (department) {
        // Hash by DepartmentId
        departmentsByDepartmentId[department.DepartmentId] = department

        // Hash by RegionId
        if (!departmentsByRegionId[department.RegionId]) {
          departmentsByRegionId[department.RegionId] = []
        }
        departmentsByRegionId[department.RegionId].push(department)
      })

      // $rootScope.$broadcast('setDepartments', departments);
    },
    updateDepartment: function (_department) {
      // var department = departmentsByDepartmentId[_department.DepartmentId]
      // TO DO !update children maybe?

      // $rootScope.$broadcast('updateDepartment', department);
    }
  }
}

export default new DepartmentService()



// WEBPACK FOOTER //
// ./src/services/DepartmentService.js